import { useNavigate } from 'react-router-dom'

import { track } from '@amplitude/analytics-browser'
import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import DescriptionItemsBlock from './components/DescriptionItemsBlock'
import Footer from './components/Footer'
import Header from './components/Header'

const PaymentSuccessPage = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  track(trackingEvents.billing.upgradePlanSuccess)

  return (
    <ResponsivePage.Body variant="full">
      <Box
        border={{
          bottom: {
            width: 's1',
            style: 'solid',
            color: 'grey400',
          },
        }}
        alignItems="center"
        paddingBottom="s64"
        gap="s64"
      >
        <Box gap="s48" alignItems="center">
          <Header />
          <DescriptionItemsBlock />
        </Box>
        <Box
          flexDirection="row"
          gap="s8"
          cursor="pointer"
          onClick={() => navigate(navigation.dashboard.fullPath())}
        >
          <Text.Normal color="grey1000" weight="medium">
            {i18n.t('pricing_plans.success.action.go_to_dashboard')}
          </Text.Normal>
          <Icon.Medium icon="arrow-right" color="grey800" />
        </Box>
      </Box>
      <Footer />
    </ResponsivePage.Body>
  )
}

export default PaymentSuccessPage
